import { render, staticRenderFns } from "./passRecord.vue?vue&type=template&id=4e1cee28&scoped=true"
import script from "./passRecord.vue?vue&type=script&lang=js"
export * from "./passRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1cee28",
  null
  
)

export default component.exports